<template>
  <div class="pop-over">
    <div>
      <div class="description">
        {{ $t('conformation_internet') }}
      </div>



      <div class="button-footer">
        <div class="navigation-buttons">
          <button class="btn btn-outline-dark back" type="submit" @click="close">
            {{ $t('back_2') }}
          </button>
        </div>

        <div class="navigation-buttons" @click="getMetadata">
            <button class="btn btn-outline-dark next" type="submit">
              {{ $t('continue') }}
            </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../../router";

export default {
  name: 'InternetAccessPopup',
  props:{
    fileContent: ''
  },
  data() {
    return {
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getMetadata(){
      axios
          .get('https://mass.cloud.ut.ee/mass-v0/mass/2024-v1')
          .then(response => {
            this.$store.commit("addMetadata", response.data)
            this.$store.state.summary['version'] = response.data.version;
            this.$store.state.answers['version'] = response.data.version;
            this.$store.state.answerFile = JSON.parse(this.fileContent);
            this.$store.commit("addAnswers");
            this.$store.state.benchmark = [];

            router.push('questionnaire')
          }).catch(function (error) {
        console.log("Failed to load data: ", error);


      })
    }
  }
};
</script>

<style scoped>
.pop-over {
  background-color: #ffff;
  position: fixed;
  margin: auto;
  max-width: 500px;
  max-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  border-radius: 15px;
  padding: 3rem;

}

.button-footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 40px 10px 10px 0;
}

.btn {
  width: 100%;
}


.description {
  font-size: 1.2rem;
  text-align: justify;
}

</style>
